import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="Component 46 \u2013 1"
      xmlns="http://www.w3.org/2000/svg"
      width={266.889}
      height={195}
      viewBox="0 0 266.889 205"
      {...props}
    >
      <path
        data-name="Path 12323"
        d="M214.553 138.668a14.859 14.859 0 01-.6-5.123c.5-7.672 6.667-13.535 8.212-20.947 1.5-7.227.585-15.414-5.153-20.617-7.932-7.187-20.4-6.4-26.05-16.553-5.058-9.091-3.953-20.087-9.466-29.183-5.193-8.552-13.5-14.394-22.246-18.893-12.66-6.552-27.359-12.2-41.764-12-16.368.24-28.044 11.355-38.989 22.151-9.646 9.5-26.634 8.642-21.686 33.2 4.413 21.866-6 20.242-15.519 28.319s-16.469 17.668-12.685 28.574c4.17 12.032-21.372 18.934-25.93 34.523-3.094 10.576 13.135 11.47 24.18 11.47s105.538-.9 145.5.355c11.021.345 21.591.695 32.557-.65 4.653-.575 9.4-1.779 13.06-4.708 11.468-9.166-.557-20.042-3.421-29.918z"
        fill="rgba(195,236,254,0.24)"
      />
      <g data-name="Layer 2">
        <g data-name="&lt;Layer&gt;">
          <path
            data-name="Path 717"
            d="M232.1 203.145c-22.218 3.253-45.108 1.9-91.878-1.505-26.257-1.912-79.066 1.255-105.423 1.505C15.579 203.328 0 186.552 0 166.084V38.439C0 17.971 15.611.174 34.795 1.379c17.814 1.118 44.018 5.547 71.332 2.835C138.614.987 200.277-1.75 232.1 1.379c19.134 1.881 34.793 16.592 34.793 37.06v127.645c-.004 20.468-15.761 34.275-34.793 37.061z"
            fill="none"
          />
          <ellipse
            data-name="Ellipse 4"
            cx={108.184}
            cy={12.266}
            rx={108.184}
            ry={12.266}
            transform="translate(23.597 162.758)"
            fill="#bed5dc"
          />
          <path
            data-name="Path 722"
            d="M107.617 119.621c-4.132-2.412-9.052-5.062-14.126-7.716a8.023 8.023 0 010-1.972c-1.328-4.975-1.053-4.191-8.784-6.869-5.547-1.924-3.656-6.7-4-11.112a13.05 13.05 0 00-.021-.247 7.2 7.2 0 00-2.018-4.61 23.6 23.6 0 01-3.776-4.965c-.084-.148-.165-.3-.247-.447-1.939-3.66-2.475-7.5.189-9.687.063-.052.123-.1.193-.152a6.815 6.815 0 011.669-.894c6.78-2.559 9.947 1.467 14.3 4.874 2.406 1.884 8.041.629 12.627 1.1l.2.021c3.618.413 6.533 1.956 6.606 7.067v.308c.228 11.3 4.406 9.608 10.54 15.1a8.361 8.361 0 012.522 3.131c3.625 10.512-6.226 16.748-15.874 17.07z"
            fill="#cfd3a3"
          />
          <path
            data-name="Path 723"
            d="M112.86 111.645l.431-.184c-.081-.19-8.456-19.27-38.325-39.655l-.264.387c29.757 20.313 38.077 39.263 38.158 39.452z"
            fill="#c4c695"
          />
          <path
            data-name="Path 724"
            d="M101.588 87.691c6.336-1 8.9-3.406 9-3.508l-.324-.338c-.026.023-2.575 2.4-8.752 3.383z"
            fill="#c4c695"
          />
          <path
            data-name="Path 725"
            d="M98.142 91.488c2.409-1.253 4.154-4.175 5.054-8.454a31.33 31.33 0 00.624-6.112l-.468.007c0 .112.112 11.263-5.424 14.142z"
            fill="#c4c695"
          />
          <path
            data-name="Path 726"
            d="M90.605 85.625c.74-.09 1.16-.182 1.178-.186l-.1-.457c-.09.02-9.049 1.948-16.9-3.489l-.268.386a23.812 23.812 0 0016.09 3.746z"
            fill="#c4c695"
          />
          <path
            data-name="Path 727"
            d="M80.766 92.173a11.09 11.09 0 005.984-3.821 8.225 8.225 0 001.42-2.613l-.454-.123c-.012.046-1.307 4.549-7.073 6.111z"
            fill="#c4c695"
          />
          <path
            data-name="Path 728"
            d="M117.693 96.32l-.292-.027a40.538 40.538 0 00-1.072-11.218 56.7 56.7 0 00-12.553-24.574l.222-.191a57.057 57.057 0 0112.619 24.715 40.612 40.612 0 011.076 11.295z"
            fill="#a0d468"
          />
          <path
            data-name="Path 729"
            d="M107.39 67.134a10.362 10.362 0 01-5.237-1.543l.165-.246a9.823 9.823 0 006.416 1.393l.044.29a8.724 8.724 0 01-1.388.106z"
            fill="#b2c9c6"
          />
          <path
            data-name="Path 730"
            d="M103.591 58.868c1.54 1.408 1.667 2.189 1.257 2.637s-1.2.391-2.739-1.017a11.757 11.757 0 01-3.418-4.615s2.055.392 4.9 2.995z"
            fill="#4d7c1b"
          />
          <path
            data-name="Path 731"
            d="M102.944 64.65c1.892.878 2.248 1.585 1.993 2.135s-1.024.74-2.918-.143a11.739 11.739 0 01-4.651-3.37s2.078-.245 5.576 1.378z"
            fill="#4d7c1b"
          />
          <path
            data-name="Path 732"
            d="M110.417 62.492c.343 1.509-.036 2.066-.626 2.2s-1.173-.206-1.515-1.715a6.942 6.942 0 01.145-4.314 6.791 6.791 0 011.996 3.829z"
            fill="#4d7c1b"
          />
          <path
            data-name="Path 733"
            d="M129.106 108.857s.191-39.186-10.443-38.831 5.69 26.285 5.273 37.69z"
            fill="rgba(160,212,104,0.34)"
          />
          <path
            data-name="Path 734"
            d="M126.222 105.109s-13.429-39.413-25.92-35.633 15.908 24.562 19.387 36.151z"
            fill="#a0d468"
          />
          <path
            data-name="Path 735"
            d="M122.57 105.431c-2.257-8.046-7.457-15.946-11.421-21.156a100.254 100.254 0 00-8.147-9.475l.234-.238a100.643 100.643 0 018.178 9.509c3.983 5.233 9.207 13.172 11.478 21.269z"
          />
          <path
            data-name="Path 736"
            d="M89.994 69.744c-.894-1.233-.574-2.019.149-2.545s1.575-.588 2.465.64a5.454 5.454 0 011.11 4.271 5.342 5.342 0 01-3.724-2.366z"
            fill="#4d7c1b"
          />
          <g data-name="Group 105">
            <path
              data-name="Path 737"
              d="M143.02 110.294s-1.233-26.018 5.837-26.087-3.035 17.615-2.436 25.178z"
              fill="#a0d468"
              opacity={0.6}
            />
          </g>
          <path
            data-name="Path 738"
            d="M144.228 108.11s8.986-30 18.491-27.508-11.267 18.91-13.56 27.719z"
            fill="#a0d468"
          />
          <path
            data-name="Path 739"
            d="M146.985 108.255c1.469-6.113 5.156-12.2 7.99-16.225a75.125 75.125 0 015.858-7.351l-.184-.171a75.747 75.747 0 00-5.88 7.378c-2.846 4.046-6.549 10.159-8.028 16.31z"
          />
          <path
            data-name="Path 746"
            d="M136.656 107.55a33.9 33.9 0 01-4.667-13.547 73.279 73.279 0 01-.517-14.693 107.8 107.8 0 012.272-16.679l1.4.332a106.762 106.762 0 00-2.237 16.452 71.855 71.855 0 00.507 14.388 32.463 32.463 0 004.452 12.958z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 747"
            d="M140.406 79.574h-.017l-13.994-1.9a.123.123 0 01-.086-.051.132.132 0 01-.026-.1 16.945 16.945 0 00-.505-5.917 18.033 18.033 0 00-7.873-10.7c-7.875-4.734-11.573-11.834-10.41-20.006a26.556 26.556 0 013.77-10.065 33.091 33.091 0 017.573-8.455 31.656 31.656 0 0110.229-5.457 26.988 26.988 0 0111.726-1.039c8.984 1.218 17.173 5.96 21.908 12.686a22.6 22.6 0 013.574 7.822 19.437 19.437 0 01.1 8.566c-2.126 10-6.41 16.366-13.088 19.452-1.164.557-11.426 5.726-12.754 15.055a.132.132 0 01-.136.113zm-13.843-2.14l13.737 1.861c1.423-9.383 11.711-14.565 12.882-15.128 6.6-3.05 10.836-9.353 12.943-19.269a19.175 19.175 0 00-.1-8.451 22.308 22.308 0 00-3.54-7.723c-4.693-6.668-12.82-11.369-21.729-12.574a26.692 26.692 0 00-11.611 1.029 31.389 31.389 0 00-10.139 5.405 32.854 32.854 0 00-7.512 8.389 26.211 26.211 0 00-3.734 9.964 18.036 18.036 0 001.954 11.458 22.338 22.338 0 008.337 8.289 18.291 18.291 0 017.99 10.871 17.546 17.546 0 01.521 5.879z"
            fill="#436e8e"
          />
          <g data-name="Group 107">
            <path
              data-name="Path 748"
              d="M124.15 30.967a2.413 2.413 0 01-1.233-.341 3.561 3.561 0 01-1.223-4.245 7.983 7.983 0 014.13-4.4 5.833 5.833 0 014.248-.64c2.945 1.022 4.464 2.034 4.643 3.093a1.748 1.748 0 01-.855 1.628.124.124 0 01-.063.027 13.357 13.357 0 00-7.026 3.551 3.748 3.748 0 01-2.621 1.327zm4.756-9.547a6.868 6.868 0 00-2.97.791 7.726 7.726 0 00-4 4.248 3.309 3.309 0 001.109 3.945c1.058.624 2.375.272 3.524-.943a13.661 13.661 0 017.15-3.625c.562-.454.809-.91.732-1.356-.11-.648-.975-1.676-4.471-2.891a3.3 3.3 0 00-1.075-.167zm4.868 4.536z"
              fill="#436e8e"
              opacity={0.4}
            />
          </g>
          <path
            data-name="Path 749"
            d="M138.64 16.018c-16.038-2.174-31.18 11.107-33.143 24.9-1.233 8.67 3.031 15.477 10.355 19.878a17.969 17.969 0 018.435 16.753l13.993 1.9c1.334-9.369 11.528-14.533 12.829-15.162 6.2-2.864 10.762-8.76 13.015-19.354 2.897-13.639-9.447-26.742-25.484-28.915z"
            fill="#ffd200"
          />
          <path
            data-name="Path 750"
            d="M139.241 75.926s4.322 1.251 2.555 6.04c0 0 2.644 3.76-.7 6.13 0 0 2.024 3.833-.891 6.89s-20.745-.93-21.9-2.974-.139-4.1 1.455-4.407c0 0-1.906-1.972-1.043-3.978s2.036-2.267 2.036-2.267-1.494-1.144-1.25-3.936 3.88-5.933 19.738-1.498z"
            fill="#003586"
          />
          <g data-name="Group 108">
            <path
              data-name="Path 751"
              d="M131.642 25.956a13.432 13.432 0 00-7.109 3.591c-2.84 3-5.929.247-4.852-3.127s5.737-5.818 8.211-4.959 6.254 2.51 3.75 4.495z"
              fill="#fff"
              opacity={0.4}
            />
          </g>
          <path
            data-name="Path 752"
            d="M141.093 88.4a.314.314 0 01-.143-.035 20.723 20.723 0 00-4.029-1.435 22.746 22.746 0 00-9.577-.407.309.309 0 11-.111-.608 23.39 23.39 0 019.862.42 21.077 21.077 0 014.142 1.479.309.309 0 01-.141.583z"
          />
          <path
            data-name="Path 753"
            d="M141.796 82.269a.306.306 0 01-.113-.022 40.206 40.206 0 00-5.07-1.524c-2.647-.616-6.463-1.189-9.6-.476a.308.308 0 01-.137-.6c3.257-.74 7.176-.149 9.889.478a40.5 40.5 0 015.148 1.548.309.309 0 01-.113.6z"
          />
          <g data-name="Group 109">
            <path
              data-name="Path 754"
              d="M133.996 74.795c0-.048-.268-4.9-.217-9.974.019-1.958.079-3.595.168-4.964a14.292 14.292 0 01-2.539-.192 124.329 124.329 0 01-2.051 14.287l-1.175-.247a127.249 127.249 0 002.044-14.307 9.368 9.368 0 01-3.638-1.882 5.465 5.465 0 01-1.676-6.214c.63-1.726 1.946-2.889 3.276-2.9h.016c.667 0 1.88.306 2.65 2.314.67 1.747.787 4.614.626 7.749a12.921 12.921 0 002.558.2c.37-4.228 1.068-5.424 1.624-5.917a4.707 4.707 0 015.67-.353 3.076 3.076 0 011.344 3.662c-.475 1.356-2.3 2.589-4.87 3.284a15.345 15.345 0 01-2.644.46 85.296 85.296 0 00-.177 5.033c-.049 5.032.212 9.848.216 9.9zm4.684-21.978a3.289 3.289 0 00-2.219.822c-.293.263-.863 1.251-1.209 4.948a14.206 14.206 0 002.236-.407c2.1-.565 3.722-1.578 4.049-2.52a1.915 1.915 0 00-.876-2.269 3.633 3.633 0 00-1.979-.574zm-10.478-3.219c-.806.006-1.714.894-2.158 2.112a4.326 4.326 0 001.331 4.893 8.124 8.124 0 002.923 1.57 19.49 19.49 0 00-.565-7.027c-.219-.583-.712-1.548-1.53-1.548z"
              fill="#fff"
              opacity={0.4}
            />
          </g>
          <path
            data-name="Path 755"
            d="M92.862 112.727l12.23 55.162a7.489 7.489 0 007.441 5.649h42.609a7.465 7.465 0 007.486-5.874l11.124-59.874z"
            fill="#165a9f"
          />
          <path
            data-name="Path 756"
            d="M88.782 110.064l-.7 4.492a2.488 2.488 0 002.712 2.752l84.14-4.535a2.49 2.49 0 002.436-2.4v-3.958a2.5 2.5 0 00-2.616-2.409l-79.658.9a6.333 6.333 0 00-6.314 5.158z"
            fill="#003586"
          />
          <path
            data-name="Path 757"
            d="M93.839 117.277a.136.136 0 01-.007-.271l78.839-4.249a.133.133 0 01.143.123.137.137 0 01-.123.143l-78.845 4.254z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 758"
            d="M206.331 178.843a.337.337 0 01-.332-.274l-12.486-64.841a.338.338 0 11.664-.123l12.486 64.841a.337.337 0 01-.267.4.29.29 0 01-.065-.003z"
            fill="#436e8e"
          />
          <path
            data-name="Path 759"
            d="M229.72 173.233a.337.337 0 01-.328-.259l-14.189-59.234a.339.339 0 11.658-.158l14.188 59.234a.336.336 0 01-.247.407.284.284 0 01-.083.01z"
            fill="#436e8e"
          />
          <path
            data-name="Rectangle 53"
            fill="#436e8e"
            d="M195.363 121.153h22.14v.783h-22.14z"
          />
          <path
            data-name="Rectangle 54"
            fill="#436e8e"
            d="M199.056 141.3l.051-.781 23.336 1.533-.051.782z"
          />
          <path
            data-name="Rectangle 55"
            fill="#436e8e"
            d="M202.704 159.423l23.654-1.898.062.78-23.653 1.899z"
          />
          <path
            data-name="Path 760"
            d="M200.6 118.101s-.032 1.289-.9 1.653-3.4.693-2.457 1.522c.542.476 3.1.168 3.821.168s1.4.314 1.935-.168c.589-.531 0-3.176 0-3.176a2.846 2.846 0 01-1.183.31 2.306 2.306 0 01-1.216-.309z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 761"
            d="M210.624 118.101s-.033 1.289-.906 1.653-3.4.693-2.457 1.521c.542.476 3.1.169 3.821.169s1.4.314 1.936-.169c.59-.531 0-3.174 0-3.174a2.844 2.844 0 01-1.182.309 2.3 2.3 0 01-1.212-.309z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 762"
            d="M194.113 82.739s-.161 5.4 1.562 15.755c1.244 7.478 2.712 15.012 3.433 18.625a2.818 2.818 0 002.633 2.288l.691.028a2.365 2.365 0 002.421-2.563l-1.748-24.44-.431-8.043z"
            fill="#ffd200"
          />
          <path
            data-name="Path 763"
            d="M209.877 87.492c-.08.657-3.8.577-8.346 0s-8.09-1.562-8.012-2.219 3.75-.74 8.3-.16 8.137 1.719 8.058 2.379z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 764"
            d="M199.336 86.597l9.714 31.2a3.127 3.127 0 002.921 2.219l.583.01a2.215 2.215 0 002.182-2.637l-5.314-29.319a.963.963 0 00-.671-.722c-1.821-.519-9.594-2.043-9.415-.751z"
            fill="#ffd200"
          />
          <path
            data-name="Path 765"
            d="M210.496 85.288l-2.2-2.558c.039-.025 4.361-2.754 3.944-6.639a6.233 6.233 0 00-3.609-4.844 12.512 12.512 0 00-3.452-1.245l.517-3.319a15.6 15.6 0 014.481 1.6 9.174 9.174 0 012.755 14.768c-1.394 1.607-1.34 1.701-2.436 2.237z"
            fill="#f7b686"
          />
          <path
            data-name="Path 766"
            d="M193.29 74.442a9.98 9.98 0 01-5.588-2.006 16.39 16.39 0 01-2.479-2.1l2.377-2.32-1.188 1.16 1.186-1.163c.838.891 3.53 3.178 5.891 3.052a3.772 3.772 0 002.827-1.71l2.589 2.064a7.017 7.017 0 01-5.261 3 3.289 3.289 0 01-.354.023z"
            fill="#f7b686"
          />
          <path
            data-name="Path 767"
            d="M208.358 69.525a5.807 5.807 0 00-5.9-3.47c-4.6.166-8.079 6.214-8.941 19.217a29.011 29.011 0 0116.37 2.2s.493-12.646-1.529-17.947z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 768"
            d="M211.974 68.757l-3.645 2.638s-8.382.838-10.61.435a3.654 3.654 0 01-2.835-2.2 11.975 11.975 0 016.4-3.423 10.989 10.989 0 011.177-.147 11.328 11.328 0 012.036.044 19.758 19.758 0 017.477 2.653z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 769"
            d="M211.97 68.758c.2.286-.458 1.109-1.464 1.837s-1.982 1.087-2.179.8.457-1.109 1.463-1.836 1.991-1.085 2.18-.801z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 770"
            d="M189.578 71.541s-.986-2.822-1.972-3.515a1.059 1.059 0 00-1.57.166l-1.022-.23s-1 4.364 2.157 4.162c.245-.01 2.407-.583 2.407-.583z"
            fill="#f7b686"
          />
          <path
            data-name="Path 771"
            d="M214.454 76.978c-.334 0-.605-.382-.605-.851s.271-.852.605-.852.6.382.6.852a1.055 1.055 0 01-.167.591.532.532 0 01-.433.26zm0-1.542c-.246 0-.445.317-.445.692s.2.69.445.69a.378.378 0 00.3-.19.9.9 0 00.141-.5c0-.375-.2-.685-.445-.685z"
            fill="#e08b65"
          />
          <path
            data-name="Path 772"
            d="M204.49 66.1a1.369 1.369 0 01-1.109-.816l-.616-1.425-.179-.414-1.047-2.432.181 2.521.11 1.513.031.431a.689.689 0 01-.567.726h-.006c-.187.3-.444.92.324 1.165a3.014 3.014 0 002.89-1.267z"
            fill="#f7b686"
          />
          <path
            data-name="Path 773"
            d="M210.07 81.606s-1.363-1.249-2.441-1.138-2.369 1.065-1.687 1.138a7.13 7.13 0 001.58-.073s-1.9.4-1.616.807 1.939.037 1.939.037-2.226.661-1.831.955 2.082-.221 2.082-.221-2.046.7-1.58 1.028 1.688-.587 1.973-.184.826 1.983 2.046 1.323z"
            fill="#f7b686"
          />
          <path
            data-name="Path 774"
            d="M203.678 100.542l-2.1-6.35a6.024 6.024 0 00-2.721-3.357l.081-.142a6.185 6.185 0 012.795 3.452l2.1 6.351z"
            fill="#020202"
          />
          <path
            data-name="Path 775"
            d="M209.002 71.445s-.2-.607.714-1.281a5.107 5.107 0 012.1-.827l.246 1.158-1.293.565z"
            fill="#f7b686"
          />
          <path
            data-name="Path 776"
            d="M204.385 60.598a2.817 2.817 0 00.141 1.261c.348 1.24-1.07 1.758-1.432 1.4-.046-.043.015-2.154.015-2.154l.452-.269z"
          />
          <path
            data-name="Path 777"
            d="M202.763 63.817v.042a1.6 1.6 0 01-.929 1.192l-.11-1.512a1.288 1.288 0 01.863-.089.357.357 0 01.176.367z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 778"
            d="M199.053 61.416a2.421 2.421 0 112.368 2.922 2.689 2.689 0 01-2.368-2.922z"
            fill="#f7b686"
          />
          <path
            data-name="Path 779"
            d="M200.486 59.171c.066.09-.307 1.593 2.478 1.951s1.109-3.019-.943-3.1c-2.966-.11-3.4 1.885-3.112 2.6s1.577-1.451 1.577-1.451z"
          />
          <path
            data-name="Path 780"
            d="M204.775 57.322s-1.251.837-.29 1.625 3.608 1.132 2.887 2.465-1.348 3.3-.048 3.544 2.117.148 2.646 1.181 2.887.393 2.695-.837 1.827-2.313.961-3.452-2.982-2.117-3.512-3.592-4.33-1.571-5.339-.934z"
          />
          <path
            data-name="Path 781"
            d="M202.658 60.65a2.786 2.786 0 01.74 2.426s.66-.721.674-.986a10.489 10.489 0 00-.16-1.241z"
          />
          <path
            data-name="Path 782"
            d="M203.471 61.857a.581.581 0 01-.837.058.652.652 0 01.133-.869.585.585 0 01.838-.058.651.651 0 01-.134.869z"
            fill="#f7b686"
          />
          <path
            data-name="Path 783"
            d="M212.086 66.537a.057.057 0 01-.02 0 .942.942 0 01-.609-.5c-.114-.316.08-.661.285-1.026a1.618 1.618 0 00.32-.947c-.053-.351-.513-.433-1-.519-.41-.074-.836-.149-1-.412a.58.58 0 01-.048-.471c.054-.207.123-.392.184-.572.274-.77.493-1.381-.72-2.775-1.551-1.79-2.835-1.876-3.993-1.7-.134.02-.477.2-.476.354 0 .081.112.284 1.11.409a3.307 3.307 0 012.1 1.849c.361.809-.151 1.674-.563 2.369-.276.467-.515.87-.441 1.14a.391.391 0 00.211.238 4.115 4.115 0 00.9.32c.783.212 1.593.43 1.7 1.842a.057.057 0 11-.112.007c-.1-1.33-.832-1.53-1.612-1.741a4.188 4.188 0 01-.925-.33.505.505 0 01-.265-.307c-.087-.317.163-.74.453-1.226.419-.709.895-1.51.557-2.266a3.183 3.183 0 00-2.024-1.782c-.809-.1-1.206-.271-1.208-.519s.424-.445.572-.467c1.189-.177 2.507-.09 4.094 1.741 1.253 1.445 1.027 2.081.74 2.887-.063.176-.123.36-.18.562a.461.461 0 00.033.382c.142.221.541.292.928.361.5.09 1.027.182 1.092.616a1.729 1.729 0 01-.334 1.019c-.188.337-.37.666-.277.932a.859.859 0 00.544.433.052.052 0 01-.014.1z"
            fill="#fff"
          />
          <path
            data-name="Path 784"
            d="M202.983 60.239a2.044 2.044 0 01-1.626-.9.057.057 0 01.045-.091.057.057 0 01.051.032 1.95 1.95 0 001.532.848.057.057 0 01.054.058.056.056 0 01-.017.04.055.055 0 01-.039.013z"
            fill="#fff"
          />
          <path
            data-name="Path 785"
            d="M207.535 81.564l-.028-.075c.022-.007.547-.2.838 0l-.047.065c-.256-.176-.758.009-.763.01z"
            fill="#dd8964"
          />
          <path
            data-name="Path 786"
            d="M207.859 82.409l-.03-.074a1.41 1.41 0 01.986 0l-.032.074a1.385 1.385 0 00-.924 0z"
            fill="#dd8964"
          />
          <path
            data-name="Path 787"
            d="M208.109 83.143l-.028-.074c.027-.01.647-.239.938 0l-.052.062c-.255-.21-.852.011-.858.012z"
            fill="#dd8964"
          />
          <path
            data-name="Path 788"
            d="M194.195 85.863a27.532 27.532 0 015.289-.059 53.767 53.767 0 019.092 1.5l-1.561.263-9.775.387-1.972-1.614z"
            fill="#ffd200"
          />
          <path
            data-name="Path 789"
            d="M200.113 63.307a5.152 5.152 0 001.618-.265.789.789 0 01-.809.851c-.509.03-.809-.586-.809-.586z"
            fill="#db6b49"
          />
          <path
            data-name="Path 790"
            d="M200.113 63.307a1.058 1.058 0 00.653.16 1.9 1.9 0 00.965-.425 7.734 7.734 0 01-1.618.265z"
            fill="#fff"
          />
          <path
            data-name="Path 791"
            d="M201.191 61.444a.054.054 0 010-.1.586.586 0 01.7.155.055.055 0 010 .076.059.059 0 01-.077 0 .914.914 0 00-.579-.129.064.064 0 01-.044-.002z"
            fill="#060633"
          />
          <path
            data-name="Path 792"
            d="M201.618 62.035c0 .129-.068.235-.162.238s-.171-.1-.176-.227.069-.235.161-.238.173.101.177.227z"
            fill="#060633"
          />
          <path
            data-name="Path 793"
            d="M199.27 61.722a.054.054 0 01-.045-.092.582.582 0 01.7-.123.055.055 0 01.027.072.059.059 0 01-.072.027.921.921 0 00-.584.1.057.057 0 01-.026.016z"
            fill="#060633"
          />
          <path
            data-name="Path 794"
            d="M199.889 62.109a.21.21 0 01-.058.282c-.085.038-.2-.026-.246-.143a.211.211 0 01.059-.282c.081-.038.193.026.245.143z"
            fill="#060633"
          />
          <path
            data-name="Path 795"
            d="M185.246 75.204l-.586-.525a8.152 8.152 0 001.658-4.968 2.143 2.143 0 00-.664-1.553c-1.292-1.091-4.146.37-5.136 1.017l-.434-.659c.166-.11 4.075-2.653 6.078-.959a2.886 2.886 0 01.943 2.1 8.986 8.986 0 01-1.859 5.547z"
            fill="#ffd200"
          />
          <path
            data-name="Path 796"
            d="M184.556 68.876a.465.465 0 01-.321-.129.493.493 0 01-.022-.679l.789-.863a.463.463 0 01.664-.023.493.493 0 01.023.679l-.79.863a.465.465 0 01-.343.152z"
            fill="#f7b686"
          />
          <path
            data-name="Path 797"
            d="M184.856 69.675a.465.465 0 01-.321-.129.493.493 0 01-.023-.68l.79-.863a.463.463 0 01.664-.023.493.493 0 01.023.679l-.79.863a.465.465 0 01-.343.153z"
            fill="#f7b686"
          />
          <path
            data-name="Path 798"
            d="M185.173 70.411a.461.461 0 01-.321-.123.493.493 0 01-.023-.68l.79-.863a.464.464 0 01.665-.023.493.493 0 01.023.679l-.79.863a.466.466 0 01-.344.147z"
            fill="#f7b686"
          />
          <path
            data-name="Path 799"
            d="M185.67 70.893a.309.309 0 01-.2-.076.326.326 0 01-.037-.451l.721-.872a.307.307 0 01.441-.038.326.326 0 01.037.452l-.72.872a.308.308 0 01-.242.113z"
            fill="#f7b686"
          />
          <path
            data-name="Path 800"
            d="M167.979 68.503l4.375 14.158a2.948 2.948 0 003.768 1.716l9.418-2.712a2.387 2.387 0 001.715-3.283l-7.388-13.365z"
            fill="#165a9f"
          />
          <path
            data-name="Path 801"
            d="M148.954 77.101c.863.265 23.062 1.054 23.062 1.054l-1.8-6.14-17.925 2.172z"
            fill="#165a9f"
          />
          <path
            data-name="Path 802"
            d="M154.175 76.116c.228 2.722-.952 5.156-2.635 5.437s-3.235-1.7-3.463-4.419.953-5.156 2.637-5.437 3.233 1.697 3.461 4.419z"
            fill="#165a9f"
          />
          <path
            data-name="Path 803"
            d="M179.277 64.595c.464 1.024-1.589 2.958-4.584 4.307s-5.8 1.621-6.263.6 1.59-2.952 4.586-4.307 5.799-1.622 6.261-.6z"
            fill="#165a9f"
          />
          <path
            data-name="Path 804"
            d="M174.244 64.471a.632.632 0 11-.793-.235.589.589 0 01.793.235z"
            fill="#fee543"
          />
          <path
            data-name="Path 805"
            d="M179.912 65.183l-11.984 4.233a.469.469 0 01-.617-.253.5.5 0 01.348-.594l11.984-4.233a.468.468 0 01.616.253.5.5 0 01-.347.594z"
            fill="#fee543"
          />
          <path
            data-name="Path 806"
            d="M150.716 73.09c.011.133-.046.253-.123.266s-.159-.083-.17-.216.047-.253.123-.266.159.083.17.216z"
            fill="#1c3442"
          />
          <path
            data-name="Path 807"
            d="M151.595 80.407c.011.133-.047.253-.123.266s-.159-.084-.17-.217.047-.247.129-.266.153.084.164.217z"
            fill="#1c3442"
          />
          <path
            data-name="Path 808"
            d="M153.199 76.262c.011.133-.047.247-.123.266s-.158-.084-.169-.217.046-.247.123-.266.158.084.169.217z"
            fill="#1c3442"
          />
          <path
            data-name="Path 809"
            d="M148.983 76.809c.012.133-.046.246-.123.266s-.159-.084-.17-.217.047-.246.123-.266.158.084.17.217z"
            fill="#1c3442"
          />
          <path
            data-name="Path 810"
            d="M149.96 75.45c.011.133-.047.253-.123.266s-.159-.082-.17-.216.047-.253.129-.266.151.085.164.216z"
            fill="#1c3442"
          />
          <path
            data-name="Path 811"
            d="M151.941 75.147c.011.133-.047.247-.123.266s-.158-.083-.169-.217.047-.247.123-.265.16.083.169.216z"
            fill="#1c3442"
          />
          <path
            data-name="Path 812"
            d="M152.348 78.401c.011.133-.047.247-.123.266s-.159-.084-.17-.217.047-.247.123-.266.159.078.17.217z"
            fill="#1c3442"
          />
          <path
            data-name="Path 813"
            d="M149.846 79.125c.011.133-.047.247-.123.266s-.158-.084-.169-.217.046-.246.123-.266.158.084.169.217z"
            fill="#1c3442"
          />
          <path
            data-name="Path 814"
            d="M150.967 77.27c.011.133-.047.247-.129.266s-.159-.083-.17-.216.047-.253.123-.266.163.083.176.216z"
            fill="#1c3442"
          />
          <path
            data-name="Path 815"
            d="M154.196 77.162a.041.041 0 01-.037-.046 5.386 5.386 0 00-.313-2.539.043.043 0 01.017-.057.042.042 0 01.057.017 5.316 5.316 0 01.322 2.589.042.042 0 01-.046.036z"
            fill="#1c3442"
          />
          <path
            data-name="Path 816"
            d="M171.684 78.239a3.522 3.522 0 01-.739-.081.042.042 0 01-.031-.051.04.04 0 01.019-.026.041.041 0 01.032 0 2.584 2.584 0 001.621-.131.812.812 0 00.37-.544c.224-1.1-3.144-4.8-3.179-4.838a.042.042 0 01.021-.071.042.042 0 01.041.014c.141.153 3.433 3.767 3.205 4.911a.9.9 0 01-.407.6 1.77 1.77 0 01-.953.217z"
            fill="#1c3442"
          />
          <path
            data-name="Path 817"
            d="M167.927 69.458a.043.043 0 01-.034-.068.041.041 0 01.028-.016 41.85 41.85 0 009.884-2.976.043.043 0 01.056.022.039.039 0 010 .033.041.041 0 01-.023.023 42.009 42.009 0 01-9.906 2.981z"
            fill="#1c3442"
          />
          <path
            data-name="Rectangle 56"
            fill="#2f1a31"
            d="M196.273 71.431l1.084-2.03.099.053-1.084 2.03z"
          />
          <path
            data-name="Rectangle 57"
            fill="#436e8e"
            d="M183.066 173.476l16.588-27.971.673.399-16.588 27.971z"
          />
          <path
            data-name="Path 818"
            d="M110.515 104.727c-.166-3.074-4.03-5.995-4.068-6.024l.392-.524c.169.123 4.148 3.136 4.331 6.512z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 819"
            d="M104.252 95.519v-.006a5.169 5.169 0 00-.979-1.53 5.515 5.515 0 00-3.67-1.775 6.83 6.83 0 01-3.444-1.059 5.547 5.547 0 01-2.17-2.835 8.057 8.057 0 01-.409-3.232 10.048 10.048 0 01.838-3.341 9.588 9.588 0 011.972-2.908 8.174 8.174 0 013-1.934 9.78 9.78 0 017.674.309 6.855 6.855 0 012.064 1.59 5.9 5.9 0 011.233 2.282c.842 2.984.592 5.3-.764 7.067-.235.317-2.273 3.173-1.3 5.885a.014.014 0 01-.007.017l-4.036 1.472zm-1.289-19.226a10.442 10.442 0 00-3.559.634 8.165 8.165 0 00-2.991 1.929 9.576 9.576 0 00-1.972 2.9 10 10 0 00-.836 3.328 8 8 0 00.408 3.222 5.506 5.506 0 002.163 2.822 6.826 6.826 0 003.437 1.05 5.544 5.544 0 013.674 1.785 5.249 5.249 0 01.979 1.526l4.011-1.463a5.475 5.475 0 01.2-3.831 9.143 9.143 0 011.119-2.067c1.356-1.763 1.6-4.068.759-7.045a5.871 5.871 0 00-1.233-2.271 6.8 6.8 0 00-2.055-1.584 9.01 9.01 0 00-4.1-.941zm-3.563.612z"
            fill="#436e8e"
          />
          <g data-name="Group 110">
            <path
              data-name="Path 820"
              d="M96.699 83.344h-.037a1.056 1.056 0 01-.906-.947 2.418 2.418 0 01.483-1.751 1.754 1.754 0 011.035-.763c.915-.138 1.473-.083 1.663.165a.511.511 0 010 .531 4.117 4.117 0 00-1.4 1.972c-.147.499-.456.793-.838.793zm1.425-3.511a5.8 5.8 0 00-.843.074 1.731 1.731 0 00-1.018.753 2.373 2.373 0 00-.478 1.726 1.027 1.027 0 00.881.926c.386.021.7-.269.842-.772a4.134 4.134 0 011.408-1.98.475.475 0 000-.5c-.115-.151-.382-.227-.792-.227zm.801.739z"
              fill="#436e8e"
              opacity={0.4}
            />
          </g>
          <path
            data-name="Path 821"
            d="M98.826 77.208c-4.625 1.688-6.821 7.409-5.4 11.4a5.874 5.874 0 005.6 3.884 5.473 5.473 0 014.645 3.315l4.036-1.472c-.969-2.712 1.044-5.547 1.307-5.9 1.264-1.649 1.656-3.883.761-7.056-1.144-4.079-6.324-5.857-10.949-4.171z"
            fill="#fee543"
          />
          <path
            data-name="Path 822"
            d="M107.476 93.252a1.292 1.292 0 011.542 1.262s1.245.637.679 1.75a1.882 1.882 0 01.74 1.981c-.349 1.235-5.717 2.69-6.318 2.3a.866.866 0 01-.233-1.392s-.791-.26-.844-.923a1.063 1.063 0 01.227-.9 1.346 1.346 0 01-.895-.883c-.33-.781.205-2.143 5.102-3.195z"
            fill="#003586"
          />
          <g data-name="Group 111">
            <path
              data-name="Path 823"
              d="M98.35 80.88a4.09 4.09 0 00-1.405 1.972c-.339 1.208-1.562.9-1.749-.155a2.387 2.387 0 011.508-2.5c.786-.123 2.036-.211 1.646.683z"
              fill="#fff"
              opacity={0.4}
            />
          </g>
          <path
            data-name="Path 824"
            d="M109.741 96.348a.131.131 0 01-.043.011 6.347 6.347 0 00-1.288.184 6.914 6.914 0 00-2.635 1.247.095.095 0 01-.117-.148 7.114 7.114 0 012.712-1.283 6.379 6.379 0 011.325-.189.1.1 0 01.095.094.1.1 0 01-.049.084z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 825"
            d="M109.062 94.597a.1.1 0 01-.033.01 12.242 12.242 0 00-1.582.308 7.03 7.03 0 00-2.653 1.233.094.094 0 01-.123-.143 7.208 7.208 0 012.73-1.272 11.967 11.967 0 011.6-.312.094.094 0 01.054.176z"
            fill="#2f1a31"
          />
          <g data-name="Group 112">
            <path
              data-name="Path 826"
              d="M104.183 94.219a38.718 38.718 0 00-1.479-4.141 2.852 2.852 0 01-1.246.009 1.663 1.663 0 01-1.331-1.436 1.2 1.2 0 01.471-1.245c.177-.095.55-.19 1.045.246a6.459 6.459 0 011.267 2 3.993 3.993 0 00.716-.309 3.291 3.291 0 01-.4-1.822 1.429 1.429 0 011.479-.9.934.934 0 01.88.795 2.04 2.04 0 01-.846 1.574 4.717 4.717 0 01-.645.493 35.238 35.238 0 002.123 4.016l-.314.186a41.653 41.653 0 01-2.131-4.014 4.387 4.387 0 01-.71.306 37.524 37.524 0 011.473 4.141zm-3.26-6.533a.313.313 0 00-.15.037.878.878 0 00-.282.875 1.314 1.314 0 001.052 1.128 2.473 2.473 0 001.011.009 5.934 5.934 0 00-1.148-1.813.828.828 0 00-.482-.231zm3.646-.712a1.073 1.073 0 00-1 .667 3.214 3.214 0 00.381 1.5 4.189 4.189 0 00.539-.423 1.875 1.875 0 00.74-1.252.583.583 0 00-.557-.493.845.845 0 00-.1.006z"
              fill="#fff"
              opacity={0.4}
            />
          </g>
          <path
            data-name="Path 827"
            d="M173.888 166.475s-4.737-4.83-3.108-7.581 4.381 5.91 4.381 5.91-1.427-10.24 1.529-10.417 0 10.417 0 10.417 1.094-2.465 2.165-2.624.764 2.1-1.147 4.3z"
            fill="#bed5dc"
          />
          <path
            data-name="Path 828"
            d="M174.226 166.595a21.56 21.56 0 01-2.479-3.158c-1.512-2.394-1.873-4.3-1.071-5.65.3-.505.661-.739 1.07-.692.817.094 1.776 1.384 2.852 3.835.328.747.616 1.493.846 2.11-.261-2.68-.564-8.02.911-9.823a1.6 1.6 0 011.163-.63 1.215 1.215 0 011.071.467c1.326 1.642.123 7.445-.532 10.16.493-.8 1.188-1.684 1.9-1.785a.694.694 0 01.757.354c.43.789-.164 2.8-1.9 4.807l-.261-.228c1.707-1.973 2.176-3.822 1.857-4.408a.349.349 0 00-.4-.178c-.916.13-1.986 2.119-2.321 2.875l-.326-.123c0-.024.654-2.358 1.089-4.914.568-3.341.522-5.535-.131-6.343a.873.873 0 00-.78-.34 1.247 1.247 0 00-.915.505c-1.864 2.275-.671 11.026-.658 11.114l-.337.077c-.616-1.946-2.528-7.027-3.922-7.191-.266-.029-.505.142-.732.524-1.759 2.97 3.452 8.336 3.5 8.383z"
            fill="#42428e"
          />
          <path
            data-name="Path 829"
            d="M41.419 169.96s-4.354-4.438-2.856-6.966 4.026 5.424 4.026 5.424-1.31-9.411 1.4-9.573 0 9.573 0 9.573 1.007-2.271 1.99-2.411.7 1.925-1.053 3.945z"
            fill="#bed5dc"
          />
          <path
            data-name="Path 830"
            d="M41.727 170.071a19.9 19.9 0 01-2.28-2.9c-1.392-2.2-1.726-3.945-.986-5.192a1.032 1.032 0 01.986-.635c.751.086 1.633 1.272 2.622 3.524.3.687.568 1.372.777 1.939-.239-2.465-.518-7.369.838-9.026a1.467 1.467 0 011.068-.579 1.12 1.12 0 01.986.43c1.219 1.509.123 6.842-.493 9.337.452-.732 1.093-1.548 1.748-1.642a.637.637 0 01.7.327c.394.725-.15 2.574-1.747 4.413l-.247-.21c1.57-1.807 2-3.515 1.709-4.052a.322.322 0 00-.37-.163c-.842.123-1.826 1.948-2.133 2.642l-.3-.108c.006-.021.6-2.166 1-4.514.521-3.072.481-5.087-.123-5.831a.8.8 0 00-.719-.312 1.145 1.145 0 00-.839.464c-1.712 2.1-.616 10.133-.605 10.214l-.293.07c-.568-1.788-2.322-6.462-3.6-6.607-.247-.028-.463.123-.673.481-1.617 2.731 3.168 7.659 3.216 7.708z"
            fill="#42428e"
          />
          <path
            data-name="Path 831"
            d="M97.149 180.56s-2.864-2.919-1.879-4.581 2.648 3.575 2.648 3.575-.863-6.189.924-6.3 0 6.3 0 6.3.662-1.494 1.308-1.585.462 1.266-.693 2.589z"
            fill="#bed5dc"
          />
          <path
            data-name="Path 832"
            d="M97.354 180.632a13.165 13.165 0 01-1.5-1.908c-.915-1.447-1.133-2.6-.647-3.416.181-.306.4-.445.646-.418.493.057 1.074.837 1.726 2.319.2.451.37.9.51 1.276-.158-1.621-.34-4.848.551-5.937a.961.961 0 01.7-.381.73.73 0 01.647.282c.8.986.078 4.5-.32 6.141.3-.481.719-1.017 1.149-1.079a.417.417 0 01.457.214c.26.477-.1 1.693-1.149 2.9l-.159-.137c1.033-1.19 1.317-2.312 1.123-2.665a.211.211 0 00-.247-.107c-.554.079-1.2 1.281-1.4 1.737l-.2-.07c0-.014.4-1.425.658-2.97.343-2.019.316-3.346-.079-3.835a.527.527 0 00-.472-.2.755.755 0 00-.552.3c-1.127 1.376-.406 6.665-.4 6.718l-.2.046c-.37-1.176-1.527-4.249-2.37-4.345-.16-.018-.306.085-.443.317-1.064 1.795 2.083 5.037 2.115 5.07z"
            fill="#42428e"
          />
          <path
            data-name="Path 833"
            d="M165.296 182.091s-3.921-4-2.571-6.273 3.625 4.89 3.625 4.89-1.181-8.475 1.265-8.622 0 8.622 0 8.622.906-2.045 1.791-2.172.632 1.735-.948 3.555z"
            fill="#bed5dc"
          />
          <path
            data-name="Path 834"
            d="M165.577 182.196a17.778 17.778 0 01-2.051-2.613c-1.252-1.981-1.551-3.555-.886-4.676a.924.924 0 01.884-.572c1.151.132 2.412 3.13 3.062 4.91a39.043 39.043 0 01-.167-2.635c-.077-2.8.234-4.645.92-5.482a1.317 1.317 0 01.961-.523 1.007 1.007 0 01.886.387c1.1 1.356.106 6.164-.44 8.408.408-.66.986-1.394 1.574-1.479a.575.575 0 01.626.293c.355.653-.136 2.319-1.573 3.974l-.217-.188c1.414-1.627 1.8-3.164 1.537-3.649a.288.288 0 00-.333-.145c-.758.107-1.645 1.753-1.922 2.378l-.269-.1c0-.02.541-1.951.9-4.068.47-2.765.433-4.581-.108-5.25a.723.723 0 00-.646-.281 1.037 1.037 0 00-.757.418c-1.542 1.884-.555 9.122-.544 9.2l-.279.063c-.513-1.61-2.1-5.818-3.247-5.95-.221-.025-.418.123-.605.434-1.457 2.458 2.851 6.9 2.9 6.941z"
            fill="#42428e"
          />
          <path
            data-name="Path 835"
            d="M215.834 178.716s-3.138-3.2-2.058-5.02 2.9 3.912 2.9 3.912-.946-6.78 1.011-6.9 0 6.9 0 6.9.726-1.636 1.434-1.737.506 1.387-.758 2.844z"
            fill="#bed5dc"
          />
          <path
            data-name="Path 836"
            d="M216.058 178.792a14.177 14.177 0 01-1.641-2.1c-1-1.585-1.241-2.844-.71-3.741.2-.335.438-.493.708-.457.92.1 1.927 2.5 2.447 3.921-.172-1.78-.37-5.3.605-6.488a1.057 1.057 0 01.769-.418.8.8 0 01.71.309c.878 1.087.084 4.931-.353 6.727.325-.526.788-1.109 1.26-1.182a.461.461 0 01.5.234c.285.523-.109 1.855-1.259 3.18l-.174-.15c1.132-1.3 1.441-2.532 1.233-2.919a.229.229 0 00-.266-.123c-.607.086-1.315 1.4-1.537 1.9l-.216-.078c0-.015.434-1.561.721-3.252.37-2.219.346-3.666-.086-4.2a.581.581 0 00-.518-.224.823.823 0 00-.605.334c-1.233 1.506-.442 7.3-.435 7.359l-.223.051c-.409-1.29-1.674-4.656-2.6-4.761-.175-.021-.334.093-.485.347-1.165 1.972 2.282 5.519 2.318 5.555z"
            fill="#42428e"
          />
          <path
            data-name="Path 837"
            d="M144.947 86.94a.089.089 0 01-.068-.012.09.09 0 01-.039-.057 2.881 2.881 0 01-.044-.465.09.09 0 11.18 0 2.989 2.989 0 00.039.433.087.087 0 01-.068.101zm-.036-.9h-.023a.091.091 0 01-.085-.095c.009-.149.023-.3.043-.455a.091.091 0 01.1-.078.09.09 0 01.06.034.088.088 0 01.017.067c-.02.148-.033.3-.042.441a.091.091 0 01-.072.088zm.123-.891a.072.072 0 01-.037 0 .09.09 0 01-.07-.106c.028-.141.063-.288.1-.443a.09.09 0 11.174.046c-.039.15-.073.3-.1.433a.09.09 0 01-.075.07zm.229-.863a.1.1 0 01-.046 0 .09.09 0 01-.053-.045.089.089 0 010-.069c.044-.139.1-.281.153-.429a.09.09 0 11.167.065c-.055.143-.1.284-.15.419a.088.088 0 01-.073.052zm.324-.838a.087.087 0 01-.055 0 .09.09 0 01-.046-.123c.061-.133.123-.27.195-.411a.09.09 0 01.161.081c-.069.137-.133.271-.191.4a.09.09 0 01-.069.044zm.4-.8a.1.1 0 01-.063-.01.09.09 0 01-.044-.054.089.089 0 01.009-.069q.107-.194.229-.392a.091.091 0 01.123-.028.09.09 0 01.03.123c-.08.129-.156.259-.227.385a.093.093 0 01-.064.039zm.471-.766a.093.093 0 01-.069-.013.089.089 0 01-.023-.123q.122-.185.259-.37a.09.09 0 01.146.106q-.133.185-.256.37a.089.089 0 01-.062.025zm.529-.727a.09.09 0 01-.089-.143c.091-.116.185-.234.285-.352a.092.092 0 01.137.123c-.1.116-.191.232-.281.346a.087.087 0 01-.058.02zm.577-.689a.094.094 0 01-.079-.021.092.092 0 01-.007-.123c.1-.111.2-.221.306-.334a.091.091 0 01.123 0 .09.09 0 010 .123c-.1.111-.206.222-.3.33a.083.083 0 01-.046.019zm.616-.653a.094.094 0 01-.083-.025.091.091 0 010-.123c.1-.1.212-.21.324-.314a.09.09 0 01.123 0 .091.091 0 010 .123c-.11.1-.217.207-.319.312a.1.1 0 01-.05.021zm.652-.616a.092.092 0 01-.086-.028.091.091 0 01.007-.123c.11-.1.223-.2.339-.3a.092.092 0 01.123.01.09.09 0 01-.01.123q-.171.148-.336.3a.091.091 0 01-.042.013z"
            fill="#81b3cc"
          />
          <path
            data-name="Path 838"
            d="M148.328 95.918a.093.093 0 01-.107-.068 47.378 47.378 0 00-.1-.438.091.091 0 01.068-.108.089.089 0 01.067.012.088.088 0 01.039.056l.1.438a.09.09 0 01-.011.068.089.089 0 01-.056.039zm-.2-.878a.09.09 0 01-.106-.069l-.031-.148c-.021-.1-.041-.195-.06-.293a.09.09 0 01.069-.106.09.09 0 01.1.07l.06.293.032.146a.09.09 0 01-.069.107zm-.179-.881a.088.088 0 01-.067-.014.09.09 0 01-.038-.058l-.083-.444a.09.09 0 01.07-.1.09.09 0 01.1.073l.081.441a.09.09 0 01-.06.102zm-.159-.886a.09.09 0 01-.1-.074c-.025-.15-.049-.3-.071-.445a.088.088 0 01.074-.1.09.09 0 01.1.074l.071.444a.09.09 0 01-.071.101zm-.138-.888a.091.091 0 01-.1-.076c-.021-.152-.042-.3-.061-.448a.093.093 0 01.076-.1.091.091 0 01.067.017.089.089 0 01.035.06c.019.145.038.293.061.444a.091.091 0 01-.017.067.09.09 0 01-.058.036zm-.123-.893h-.007a.091.091 0 01-.1-.079l-.049-.447a.1.1 0 01.08-.1.09.09 0 01.1.08c.016.148.032.3.05.446a.091.091 0 01-.065.1zm-.094-.895h-.01a.09.09 0 01-.1-.083c-.015-.152-.027-.3-.038-.449a.087.087 0 01.083-.1.091.091 0 01.1.083c.011.147.024.295.037.446a.09.09 0 01-.065.1zm-.068-.9h-.012a.092.092 0 01-.1-.085c-.009-.152-.017-.3-.023-.45a.085.085 0 01.022-.065.087.087 0 01.063-.028.091.091 0 01.065.023.089.089 0 01.03.062c0 .148.014.3.023.449a.089.089 0 01-.065.1zm-.041-.9h-.016a.09.09 0 01-.092-.088c0-.153-.008-.3-.01-.451a.09.09 0 11.18 0c0 .148 0 .3.01.449a.089.089 0 01-.065.093zm-.011-.9h-.018a.091.091 0 01-.09-.091q0-.229.007-.451a.094.094 0 01.091-.089.09.09 0 01.088.092v.449a.09.09 0 01-.072.09zm.021-.9a.068.068 0 01-.022 0 .089.089 0 01-.063-.029.091.091 0 01-.024-.065l.024-.451a.091.091 0 01.1-.084.089.089 0 01.084.095c-.009.147-.016.3-.024.448a.089.089 0 01-.065.086zm.055-.9a.09.09 0 01-.107-.1c.012-.153.027-.3.042-.449a.086.086 0 01.1-.08.091.091 0 01.081.1c-.016.144-.03.293-.043.446a.088.088 0 01-.065.08zm.095-.895a.081.081 0 01-.031 0 .09.09 0 01-.078-.1c.02-.153.04-.3.064-.447a.094.094 0 01.1-.075.09.09 0 01.075.1c-.022.144-.043.292-.063.443a.089.089 0 01-.064.078zm.135-.888a.076.076 0 01-.033 0 .09.09 0 01-.059-.037.089.089 0 01-.014-.068c.027-.152.056-.3.085-.443a.089.089 0 01.106-.07.09.09 0 01.07.106c-.03.143-.058.29-.085.439a.089.089 0 01-.064.073zm.184-.881a.105.105 0 01-.04 0 .09.09 0 01-.066-.108c.036-.152.073-.3.11-.439a.091.091 0 01.175.047 13.64 13.64 0 00-.11.433.09.09 0 01-.063.068zm.233-.863a.089.089 0 01-.1-.113c.046-.152.093-.295.139-.431a.09.09 0 11.17.059c-.047.134-.092.276-.137.424a.09.09 0 01-.062.057zm.291-.852a.091.091 0 01-.051 0 .09.09 0 01-.05-.048.089.089 0 010-.069c.058-.148.115-.289.173-.418a.09.09 0 01.051-.051.091.091 0 01.072 0 .088.088 0 01.05.052.089.089 0 010 .072c-.055.131-.111.269-.169.413a.091.091 0 01-.064.048zm.359-.824a.1.1 0 01-.058-.007.089.089 0 01-.047-.053.091.091 0 01.006-.07 6.74 6.74 0 01.211-.4.09.09 0 01.123-.035.089.089 0 01.043.054.087.087 0 01-.009.069c-.065.123-.134.247-.206.394a.09.09 0 01-.058.046zm.441-.785a.088.088 0 01-.068-.012.09.09 0 01-.026-.123 3.247 3.247 0 01.273-.37.091.091 0 01.123 0 .089.089 0 01.006.123 3.511 3.511 0 00-.256.353.091.091 0 01-.047.025z"
            fill="#81b3cc"
          />
          <path
            data-name="Path 839"
            d="M143.603 82.752a.1.1 0 01-.041 0 .09.09 0 01-.064-.11.083.083 0 01.014-.03.09.09 0 01.154.091.091.091 0 01-.063.049zm.224-.395a.093.093 0 01-.065-.011.089.089 0 01-.031-.123c.08-.132.162-.26.247-.383a.089.089 0 11.146.1q-.123.181-.246.37a.1.1 0 01-.051.048zm.507-.74a.093.093 0 01-.075-.017.09.09 0 01-.015-.123c.094-.123.189-.239.285-.353a.092.092 0 11.138.123c-.1.111-.188.227-.281.345a.1.1 0 01-.052.021zm.583-.684a.088.088 0 01-.08-.022.09.09 0 010-.123c.106-.111.213-.218.321-.322a.087.087 0 11.123.123c-.1.1-.211.206-.315.314a.092.092 0 01-.049.026zm.651-.617a.09.09 0 01-.086-.029.091.091 0 01.009-.123q.175-.15.351-.288a.091.091 0 01.123.016.09.09 0 01-.016.123 7.753 7.753 0 00-.344.282.1.1 0 01-.037.012zm.709-.556a.09.09 0 01-.07-.161c.123-.089.247-.174.37-.247a.087.087 0 01.067-.013.088.088 0 01.056.04.09.09 0 01-.027.123c-.123.079-.247.163-.37.247a.088.088 0 01-.026.007zm.755-.486a.09.09 0 01-.1-.043.092.092 0 01.032-.123c.137-.079.27-.153.4-.219a.085.085 0 01.123.037.087.087 0 01.007.07.089.089 0 01-.045.053c-.123.066-.255.138-.39.217a.085.085 0 01-.03 0zm.8-.419a.09.09 0 01-.057-.169c.148-.07.287-.131.415-.184a.083.083 0 01.073-.006.085.085 0 01.05.054.09.09 0 010 .073.089.089 0 01-.052.051c-.123.053-.263.113-.408.18a.067.067 0 01-.025-.006zm.832-.346a.09.09 0 01-.1-.125.089.089 0 01.051-.046c.271-.1.432-.139.439-.141a.1.1 0 01.109.065.089.089 0 01-.064.109s-.161.042-.422.136z"
            fill="#81b3cc"
          />
          <path
            data-name="Path 840"
            d="M150.23 94.673a.09.09 0 01-.106-.067 16.95 16.95 0 01-.1-.439.09.09 0 01.069-.109.09.09 0 01.106.068c.032.144.065.291.1.438a.089.089 0 01-.067.109zm-.2-.876a.09.09 0 01-.106-.069l-.042-.2-.05-.247a.09.09 0 01.07-.106.091.091 0 01.106.07l.051.247.041.195a.09.09 0 01-.012.068.089.089 0 01-.057.039zm-.179-.881a.09.09 0 01-.1-.072q-.043-.223-.082-.444a.089.089 0 01.07-.1.089.089 0 01.1.073c.026.146.053.292.082.441a.09.09 0 01-.012.068.089.089 0 01-.057.038zm-.158-.886a.089.089 0 01-.1-.074c-.026-.149-.049-.3-.071-.444a.089.089 0 01.07-.1.091.091 0 01.1.075c.022.147.047.295.072.443a.091.091 0 01-.069.1zm-.137-.889a.09.09 0 01-.1-.075c-.022-.152-.042-.3-.06-.449a.1.1 0 01.078-.1.091.091 0 01.1.079c.019.147.038.295.06.445a.09.09 0 01-.077.1zm-.114-.892h-.009a.089.089 0 01-.066-.019.088.088 0 01-.033-.06l-.05-.449a.1.1 0 01.08-.1.09.09 0 01.1.08c.015.147.03.3.047.446a.09.09 0 01-.07.1zm-.09-.9h-.009a.09.09 0 01-.1-.081 38.72 38.72 0 01-.036-.45.09.09 0 01.149-.074.089.089 0 01.031.062c.011.147.022.3.036.446a.09.09 0 01-.072.1zm-.065-.9h-.008a.088.088 0 01-.094-.084c-.01-.153-.017-.3-.023-.45a.09.09 0 01.151-.071.09.09 0 01.029.063c0 .147.014.3.022.448a.09.09 0 01-.078.1zm-.038-.9h-.016a.09.09 0 01-.093-.087c0-.153 0-.3-.008-.451a.09.09 0 11.18 0c0 .147 0 .3.009.449a.089.089 0 01-.072.091zm-.01-.9h-.019a.09.09 0 01-.09-.09v-.451a.092.092 0 01.091-.089.091.091 0 01.089.092v.448a.089.089 0 01-.071.095zm.019-.9h-.021a.09.09 0 01-.062-.029.092.092 0 01-.024-.065c0-.153.013-.3.021-.45a.094.094 0 01.095-.085.087.087 0 01.084.095c-.007.146-.015.295-.021.446a.09.09 0 01-.071.089zm.052-.9a.1.1 0 01-.026 0 .092.092 0 01-.083-.1l.038-.451a.09.09 0 01.1-.081.091.091 0 01.081.1c-.014.144-.027.295-.038.447a.089.089 0 01-.072.084zm.085-.9a.056.056 0 01-.029 0 .09.09 0 01-.079-.1c.019-.155.037-.3.057-.448a.091.091 0 01.1-.076.088.088 0 01.076.1c-.019.143-.038.291-.056.444a.09.09 0 01-.071.08zm.123-.891a.069.069 0 01-.032 0 .09.09 0 01-.075-.1c.026-.155.052-.3.078-.445a.09.09 0 01.1-.071.092.092 0 01.073.106c-.026.138-.052.286-.076.441a.093.093 0 01-.071.074zm.166-.884a.074.074 0 01-.037 0 .088.088 0 01-.069-.106c.034-.161.069-.309.1-.441a.09.09 0 01.175.043c-.034.13-.067.276-.1.436a.093.093 0 01-.07.069zm.219-.873a.089.089 0 01-.043 0 .087.087 0 01-.06-.111c.083-.285.141-.43.142-.436a.093.093 0 01.123-.051.09.09 0 01.05.123s-.057.144-.138.42a.089.089 0 01-.074.055z"
            fill="#81b3cc"
          />
          <path
            data-name="Path 853"
            d="M73.233 123.918c.152.059 2.791.343 3.789 4.83.863 3.868-2.632.8-2.632.8z"
            fill="#f7b686"
          />
          <path
            data-name="Path 854"
            d="M69.912 176.598s.033 1.367.959 1.753 3.6.74 2.6 1.613c-.574.5-3.283.177-4.047.177s-1.479.334-2.051-.179c-.625-.562 0-3.364 0-3.364a3.05 3.05 0 001.254.328 2.442 2.442 0 001.285-.328z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 855"
            d="M59.295 176.598s.035 1.367.959 1.752 3.606.74 2.6 1.612c-.574.5-3.281.179-4.047.179s-1.479.333-2.05-.179c-.625-.562 0-3.364 0-3.364a3.064 3.064 0 001.254.328 2.45 2.45 0 001.284-.328z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 856"
            d="M76.786 139.129s.171 5.721-1.656 16.7c-1.318 7.923-2.875 15.908-3.638 19.736a2.986 2.986 0 01-2.79 2.425l-.74.03a2.5 2.5 0 01-2.565-2.712l1.849-25.9.456-8.524z"
            fill="#003586"
          />
          <path
            data-name="Path 857"
            d="M60.081 144.163c.085.7 4.022.616 8.844 0s8.572-1.656 8.489-2.352-3.973-.78-8.794-.17-8.619 1.826-8.539 2.522z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 858"
            d="M71.251 143.215l-10.292 33.064a3.32 3.32 0 01-3.1 2.357l-.616.01a2.347 2.347 0 01-2.31-2.795l5.63-31.064a1.019 1.019 0 01.71-.766c1.931-.561 10.168-2.173 9.978-.806z"
            fill="#003586"
          />
          <path
            data-name="Path 859"
            d="M61.691 125.127a6.152 6.152 0 016.247-3.677c4.878.175 8.562 6.587 9.475 20.363a30.746 30.746 0 00-17.346 2.336s-.518-13.406 1.624-19.022z"
            fill="#ff3539"
          />
          <path
            data-name="Path 860"
            d="M58.082 125.469l3.639 1.64s9.549 2.151 11.907 1.726a5.742 5.742 0 003.6-2.618s-3.781-3.883-8.05-4.647a11.617 11.617 0 00-1.233-.116 12.092 12.092 0 00-2.158.048c-6.025.649-7.705 3.967-7.705 3.967z"
            fill="#ff3539"
          />
          <path
            data-name="Path 861"
            d="M66.652 157.993l-.165-.054 2.219-6.729a6.546 6.546 0 012.958-3.651l.086.15a6.375 6.375 0 00-2.883 3.555z"
            fill="#020202"
          />
          <path
            data-name="Path 862"
            d="M71.285 120.592l-.012-.055a1.271 1.271 0 00.8-.577.835.835 0 00-.129-.765l-.231-.37c-.484-.773-.666-1.062-.532-1.694l.055.012c-.123.609.037.871.525 1.65.07.112.148.234.231.37a.885.885 0 01.133.817 1.29 1.29 0 01-.84.612z"
            fill="#e28569"
          />
          <path
            data-name="Path 863"
            d="M71.21 117.138a2.877 2.877 0 00.433 2c.648 1.024-.057 1.773-.936 1.379s-1.213.725-2.335.106 2.838-3.485 2.838-3.485z"
          />
          <path
            data-name="Path 864"
            d="M66.023 121.465a1.356 1.356 0 001.1-.8l.6-1.4.175-.408 1.032-2.4-.179 2.483-.107 1.49-.031.425a.678.678 0 00.56.715h.006c.182.3.436.9-.321 1.145a2.97 2.97 0 01-2.847-1.248z"
            fill="#f7b686"
          />
          <path
            data-name="Path 865"
            d="M67.724 119.215v.041a1.578 1.578 0 00.916 1.175l.107-1.49a1.273 1.273 0 00-.853-.088.353.353 0 00-.17.362z"
            fill="#2f1a31"
          />
          <ellipse
            data-name="Ellipse 5"
            cx={2.334}
            cy={2.878}
            rx={2.334}
            ry={2.878}
            transform="translate(66.713 113.971)"
            fill="#f7b686"
          />
          <path
            data-name="Path 866"
            d="M67.025 117.283a.573.573 0 00.826.058.642.642 0 00-.132-.857.573.573 0 00-.826-.057.64.64 0 00.132.856z"
            fill="#f7b686"
          />
          <path
            data-name="Path 867"
            d="M70.303 118.711a5.06 5.06 0 01-1.594-.261.775.775 0 00.8.837c.499.032.794-.576.794-.576z"
            fill="#db6b49"
          />
          <path
            data-name="Path 868"
            d="M70.303 118.711a1.043 1.043 0 01-.643.158 1.869 1.869 0 01-.95-.419 7.794 7.794 0 001.593.261z"
            fill="#fff"
          />
          <path
            data-name="Path 869"
            d="M69.278 116.877a.051.051 0 00.035-.031.052.052 0 00-.03-.069.576.576 0 00-.687.153.053.053 0 000 .075.058.058 0 00.075 0 .914.914 0 01.57-.123.055.055 0 00.037-.005z"
            fill="#060633"
          />
          <path
            data-name="Path 870"
            d="M68.852 117.46c0 .123.068.232.159.235s.17-.1.174-.224-.068-.232-.159-.234-.17.097-.174.223z"
            fill="#060633"
          />
          <path
            data-name="Path 871"
            d="M71.166 117.154a.054.054 0 00.044-.016.053.053 0 000-.075.576.576 0 00-.694-.123.056.056 0 00-.027.07.059.059 0 00.07.027.909.909 0 01.577.1.048.048 0 00.03.017z"
            fill="#060633"
          />
          <path
            data-name="Path 872"
            d="M70.555 117.533a.206.206 0 00.058.277c.084.038.193-.025.247-.141a.175.175 0 10-.3-.137z"
            fill="#060633"
          />
          <path
            data-name="Path 873"
            d="M70.037 114.493a1.339 1.339 0 01-1.3 1.168c-1.246.17-2.108.7-1.94 1.6s2.178 2.763.7 3.485-1.162-.625-2.765-.312-1.89-1.827-.788-3.068.657-4.527 4.793-4.381 2.621 3.452 2.621 3.452-1.323-.841-1.321-1.944z"
          />
          <path
            data-name="Path 874"
            d="M67.075 120.93l-.012-.032a.826.826 0 00.549-.533c.178-.654-.6-1.659-1.282-2.545-.181-.235-.353-.457-.5-.669a1.589 1.589 0 01-.1-1.839 1.822 1.822 0 012-.668 2.327 2.327 0 001.677-.154 1.533 1.533 0 00.509-.423l.027.018a1.509 1.509 0 01-.52.434 2.368 2.368 0 01-1.7.158 1.8 1.8 0 00-1.965.653 1.538 1.538 0 00.1 1.8c.152.212.323.434.5.668.689.894 1.469 1.9 1.287 2.575a.868.868 0 01-.57.557z"
            fill="#fff"
          />
          <path
            data-name="Path 875"
            d="M71.005 119.041a.667.667 0 01-.357-.1 1.907 1.907 0 01-.422-2.1 1.564 1.564 0 01.823-1.034.668.668 0 01.606.061 1.906 1.906 0 01.422 2.1 1.558 1.558 0 01-.823 1.034.718.718 0 01-.249.044zm-.68-2.171a1.809 1.809 0 00.378 1.979.581.581 0 00.514.049 1.471 1.471 0 00.762-.969 1.793 1.793 0 00-.378-1.972.575.575 0 00-.515-.049 1.47 1.47 0 00-.761.969z"
            fill="#6f4975"
          />
          <g data-name="Group 113">
            <path
              data-name="Path 876"
              d="M67.525 116.286a1.792 1.792 0 00.668 1.972c.556.267 1.159-.184 1.346-1a1.789 1.789 0 00-.668-1.972c-.557-.272-1.158.179-1.346 1z"
              fill="#fff"
              opacity={0.3}
            />
          </g>
          <g data-name="Group 114">
            <path
              data-name="Path 877"
              d="M70.204 116.905a1.907 1.907 0 00.558 2c.5.273 1.049-.164 1.233-.986a1.919 1.919 0 00-.558-2c-.496-.274-1.049.16-1.233.986z"
              fill="#fff"
              opacity={0.3}
            />
          </g>
          <path
            data-name="Path 878"
            d="M68.588 118.361a.863.863 0 01-.37-.088 1.889 1.889 0 01-.74-2.114 1.552 1.552 0 01.749-1.077.862.862 0 01.757 0 1.89 1.89 0 01.74 2.114 1.555 1.555 0 01-.752 1.079.884.884 0 01-.384.086zm.022-3.267a.771.771 0 00-.34.081 1.461 1.461 0 00-.694 1.008 1.8 1.8 0 00.684 2 .774.774 0 00.666 0 1.467 1.467 0 00.7-1.01 1.8 1.8 0 00-.684-2 .783.783 0 00-.332-.079z"
            fill="#6f4975"
          />
          <path
            data-name="Path 879"
            d="M70.313 117.214a.1.1 0 01-.062-.023.874.874 0 00-.7-.123.1.1 0 01-.115-.076.1.1 0 01.078-.112 1.044 1.044 0 01.857.163.1.1 0 01.011.136.091.091 0 01-.069.035z"
            fill="#6f4975"
          />
          <path
            data-name="Path 880"
            d="M58.082 125.469c-.054.37 1.162.88 2.712 1.153s2.859.2 2.913-.166-1.164-.88-2.718-1.153-2.853-.198-2.907.166z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 881"
            d="M63.958 143.409s9.615-1.838 12.741-.971l-1.5 2.219-5.555.312z"
            fill="#003586"
          />
          <path
            data-name="Path 882"
            d="M114.037 179.929a.262.262 0 01-.208-.191l-7.007-22.82c-.037-.139.955-.282 1.095-.319a.263.263 0 01.32.185l6.1 22.819a.261.261 0 01-.185.321.243.243 0 01-.115.005z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 883"
            d="M89.39 182.798a.261.261 0 01-.182-.216l-4-23.535c-.018-.143.986-.156 1.128-.175a.262.262 0 01.294.226l3.094 23.422a.264.264 0 01-.226.295.255.255 0 01-.108-.017z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 884"
            d="M74.836 178.073a.378.378 0 00.268-.289l6.626-30.844c.032-.189-1.392-.165-1.6-.184a.394.394 0 00-.427.3l-5.335 30.654a.327.327 0 00.308.37.406.406 0 00.16-.007z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 885"
            d="M76.38 126.155l27.137-1.508a1.776 1.776 0 011.78 1.2l10.6 31.266a1.777 1.777 0 01-1.125 2.257L83.96 169.541a1.775 1.775 0 01-2.306-1.383l-6.927-39.929a1.776 1.776 0 011.652-2.077z"
            fill="#6f4975"
          />
          <path
            data-name="Path 886"
            d="M78.219 127.028l24.853-1.4a1.627 1.627 0 011.63 1.116l9.71 29a1.652 1.652 0 01-1.031 2.1l-28.219 9.436a1.626 1.626 0 01-2.113-1.282l-6.342-37.043a1.642 1.642 0 011.513-1.927z"
            fill="#fee543"
          />
          <path
            data-name="Path 887"
            d="M94.24 149.708a.066.066 0 01-.058-.036 5.478 5.478 0 00-3.776-3.1 6.417 6.417 0 01-5.514-5.014c-.918-4.285 1.842-9.369 6.028-11.094a8.614 8.614 0 011.431-.452 10.641 10.641 0 018.233 1.429 6.876 6.876 0 013.015 4.66c.483 3.342-.117 5.8-1.835 7.52-.247.256-2.422 2.568-2.322 5.266a.07.07 0 01-.028.057.067.067 0 01-.063 0 1.518 1.518 0 00-.63-.123 11 11 0 00-4.363.837l-.095.036a.053.053 0 01-.023.014zm.581-19.839a11.276 11.276 0 00-2.442.268 8.555 8.555 0 00-1.409.445c-4.132 1.708-6.855 6.722-5.949 10.949a6.3 6.3 0 005.413 4.915 5.559 5.559 0 013.837 3.115l.042-.015a11.089 11.089 0 014.406-.846 1.668 1.668 0 01.589.091c-.046-2.712 2.114-5.007 2.363-5.264 1.687-1.689 2.276-4.114 1.8-7.412a6.752 6.752 0 00-2.958-4.571 10.062 10.062 0 00-5.693-1.679z"
          />
          <path
            data-name="Path 888"
            d="M88.658 136.657a.945.945 0 01-.153-.014 1.194 1.194 0 01-.88-1.194 2.656 2.656 0 01.782-1.849 1.916 1.916 0 011.255-.689c1.034-.019 1.627.124 1.808.439a.6.6 0 01-.08.624.066.066 0 01-.025.023 4.381 4.381 0 00-1.759 1.889 1.089 1.089 0 01-.948.771zm1.181-3.616h-.175a1.779 1.779 0 00-1.162.647 2.522 2.522 0 00-.746 1.752 1.071 1.071 0 00.773 1.071c.386.07.74-.184.958-.679a4.445 4.445 0 011.8-1.944.471.471 0 00.069-.475c-.1-.171-.45-.372-1.517-.372zm1.5.9z"
            fill="#436e8e"
          />
          <path
            data-name="Path 889"
            d="M93.836 149.899h-.018a.065.065 0 01-.039-.032 5.834 5.834 0 00-4.031-3.047 6.426 6.426 0 01-5.513-5.016 10.332 10.332 0 016.691-11.341c.247-.081.512-.152.767-.208a10.648 10.648 0 018.236 1.43 6.869 6.869 0 013.014 4.658c.483 3.342-.123 5.8-1.836 7.52a8.262 8.262 0 00-2.322 4.906.065.065 0 01-.065.063 10.694 10.694 0 00-4.223.781 5.372 5.372 0 00-.629.279.064.064 0 01-.032.007zm.324-19.788a11.312 11.312 0 00-2.438.266 8.698 8.698 0 00-.757.206 9.752 9.752 0 00-5.41 4.576 9.626 9.626 0 00-1.192 6.614 6.3 6.3 0 005.412 4.915 5.973 5.973 0 014.089 3.057 5.645 5.645 0 01.587-.257 10.756 10.756 0 014.206-.79 8.468 8.468 0 012.357-4.931c1.686-1.689 2.275-4.112 1.8-7.411a6.747 6.747 0 00-2.958-4.57 10.073 10.073 0 00-5.696-1.674z"
            fill="#436e8e"
          />
          <path
            data-name="Path 890"
            d="M95.029 156.339a1.876 1.876 0 01-1-.167 1.152 1.152 0 01-.439-.964.863.863 0 01.306-.607 1.319 1.319 0 01-.719-1.122 1.4 1.4 0 01.317-.909 1.606 1.606 0 01-.778-1.078c-.1-.37-.1-1.092 1.085-1.717 2.827-1.177 5.318-1.422 6.2-.616a1.065 1.065 0 01.263 1.151 2.133 2.133 0 01.507.561 1.28 1.28 0 01-.018 1.431 2.087 2.087 0 01.486 2.266c-.286.657-1.842 1.11-2.744 1.318a17.229 17.229 0 01-3.466.453zm3.279-7.52a12.421 12.421 0 00-4.446 1.069c-1.04.55-1.127 1.155-1.014 1.564a1.383 1.383 0 00.79 1.029.066.066 0 01.016.123 1.125 1.125 0 00-.342.882c-.036.672.732 1.044.74 1.048a.065.065 0 01.037.057.066.066 0 01-.031.059.709.709 0 00-.333.567 1.024 1.024 0 00.393.854c.293.246 2.359.154 4.353-.31 1.494-.349 2.465-.8 2.653-1.243a1.949 1.949 0 00-.493-2.157.065.065 0 01-.01-.085 1.145 1.145 0 00.044-1.335 2.03 2.03 0 00-.508-.55.065.065 0 01-.025-.074.948.948 0 00-.212-1.06 2.417 2.417 0 00-1.612-.434zm2.876 5.721z"
          />
          <path
            data-name="Path 891"
            d="M100.713 152.41a.108.108 0 01-.048 0 6.983 6.983 0 00-1.408.016 7.468 7.468 0 00-3.007.965.1.1 0 11-.1-.175 7.7 7.7 0 013.1-.993 7.04 7.04 0 011.448-.015.1.1 0 01.089.115.1.1 0 01-.074.087z"
          />
          <path
            data-name="Path 892"
            d="M100.229 150.434a.113.113 0 01-.037.006 12.706 12.706 0 00-1.741.106 7.613 7.613 0 00-3.023.947.102.102 0 11-.111-.172 7.8 7.8 0 013.111-.977 12.969 12.969 0 011.768-.107.101.101 0 01.032.2z"
          />
          <path
            data-name="Path 893"
            d="M95.24 149.373a.065.065 0 01-.064-.055 41.219 41.219 0 00-1.035-4.777 3 3 0 01-1.386-.15 1.673 1.673 0 01-1.14-1.6 1.2 1.2 0 01.6-1.146c.173-.064.524-.1.942.37a7.008 7.008 0 011.085 2.384 4.392 4.392 0 001.089-.308 3.612 3.612 0 01-.239-2.019 1.414 1.414 0 011.558-.687.876.876 0 01.732.853 2.146 2.146 0 01-1.076 1.46 5.151 5.151 0 01-.823.468c.137.451.323 1 .571 1.656.581 1.541 1.233 2.982 1.241 3a.067.067 0 01-.033.088.065.065 0 01-.05 0 .064.064 0 01-.036-.035 45.448 45.448 0 01-1.812-4.655 4.554 4.554 0 01-1.087.311 40.045 40.045 0 011.029 4.775.068.068 0 01-.056.075zm-2.815-7.643a.465.465 0 00-.168.031 1.059 1.059 0 00-.513 1.022 1.543 1.543 0 001.055 1.479 2.86 2.86 0 001.3.147 7.031 7.031 0 00-1.049-2.315.9.9 0 00-.625-.364zm3.916-.254a1.28 1.28 0 00-1.139.655c-.1.193-.116.691.247 1.9a4.782 4.782 0 00.785-.449 2.063 2.063 0 001.021-1.356.742.742 0 00-.63-.729 1.209 1.209 0 00-.283-.021z"
          />
          <path
            data-name="Path 894"
            d="M82.804 149.496l-.08-.023 1.389-4.975a3.171 3.171 0 01.9-1.488 4.507 4.507 0 012.143-1.1l4.959-1.024.017.083-4.96 1.023a4.421 4.421 0 00-2.1 1.076 3.073 3.073 0 00-.876 1.448z"
            fill="#436e8e"
          />
          <path
            data-name="Path 895"
            d="M92.484 140.876a.4.4 0 00-.425-.246c-.233 0-.277.2-.246.37a.358.358 0 00.38.288.385.385 0 00.291-.412z"
            fill="#e28569"
          />
          <path
            data-name="Path 896"
            d="M83.095 149.415c-.034-.169-.247-.256-.424-.246-.233 0-.277.2-.247.37a.355.355 0 00.378.288.383.383 0 00.293-.412z"
            fill="#e28569"
          />
          <path
            data-name="Path 897"
            d="M108.297 150.459l-1.329-4.887a4.451 4.451 0 00-1.2-2.031 3.1 3.1 0 00-1.5-.785l-5.054-1.078.017-.081 5.054 1.078a3.166 3.166 0 011.541.808 4.517 4.517 0 011.227 2.068l1.329 4.886z"
            fill="#436e8e"
          />
          <path
            data-name="Path 898"
            d="M108.413 150.804c.166-.046.24-.267.226-.439-.02-.233-.217-.265-.383-.221a.357.357 0 00-.265.4.385.385 0 00.422.26z"
            fill="#e28569"
          />
          <path
            data-name="Path 899"
            d="M99.308 141.964c.167-.046.24-.268.226-.44-.02-.232-.217-.265-.383-.219a.356.356 0 00-.265.4.387.387 0 00.422.259z"
            fill="#e28569"
          />
          <path
            data-name="Path 900"
            d="M92.933 136.556l-.011-.082 5.118-.7a3.082 3.082 0 001.555-.672 4.427 4.427 0 001.356-1.937l1.686-4.776.079.028-1.686 4.774a4.522 4.522 0 01-1.377 1.972 3.167 3.167 0 01-1.6.69z"
            fill="#436e8e"
          />
          <path
            data-name="Path 901"
            d="M102.774 128.049c.163.058.219.284.192.455-.037.23-.235.247-.4.191a.357.357 0 01-.235-.415.384.384 0 01.443-.231z"
            fill="#e28569"
          />
          <path
            data-name="Path 902"
            d="M93.041 136.196a.413.413 0 01.192.455c-.037.23-.236.247-.4.19a.355.355 0 01-.235-.414.385.385 0 01.443-.231z"
            fill="#e28569"
          />
          <path
            data-name="Path 903"
            d="M90.661 152.414l-5.5 1.288a.3.3 0 01-.354-.219l-.74-3.174a.3.3 0 01.219-.354l5.5-1.289a.3.3 0 01.355.219l.74 3.174a.3.3 0 01-.22.355z"
            fill="#e28569"
          />
          <path
            data-name="Path 904"
            d="M89.318 150.912l-3.767.884a.265.265 0 01-.261-.123.208.208 0 01.171-.269l3.792-.8a.155.155 0 01.186.116.156.156 0 01-.121.193z"
            fill="#deebe9"
          />
          <path
            data-name="Path 905"
            d="M88.171 150.432l-2.848.668a.2.2 0 01-.2-.1.16.16 0 01.123-.213l2.864-.6a.123.123 0 01.142.095.123.123 0 01-.081.15z"
            fill="#deebe9"
          />
          <path
            data-name="Path 906"
            d="M88.509 151.855l-2.847.668a.2.2 0 01-.2-.1.16.16 0 01.123-.215l2.862-.6a.123.123 0 01.143.094.123.123 0 01-.081.153z"
            fill="#deebe9"
          />
          <path
            data-name="Path 907"
            d="M106.44 148.265l-3.821.9a.206.206 0 01-.247-.153l-.518-2.207a.206.206 0 01.153-.247l3.821-.9a.206.206 0 01.246.153l.517 2.207a.2.2 0 01-.151.247z"
            fill="#74a1bd"
          />
          <path
            data-name="Path 908"
            d="M105.506 147.227l-2.621.616a.184.184 0 01-.182-.081.144.144 0 01.123-.187l2.635-.556a.108.108 0 01.123.08.107.107 0 01-.078.128z"
            fill="#deebe9"
          />
          <path
            data-name="Path 909"
            d="M104.709 146.89l-1.972.463a.138.138 0 01-.138-.066.11.11 0 01.088-.148l1.99-.418a.084.084 0 01.1.065.085.085 0 01-.065.1z"
            fill="#deebe9"
          />
          <path
            data-name="Path 910"
            d="M104.941 147.881l-1.972.464a.138.138 0 01-.138-.066.109.109 0 01.087-.148l1.99-.418a.084.084 0 01.1.067.084.084 0 01-.065.1z"
            fill="#deebe9"
          />
          <path
            data-name="Path 911"
            d="M92.742 159.303l-7.729 1.812a.415.415 0 01-.493-.308l-1.047-4.464a.414.414 0 01.309-.493l7.729-1.812a.414.414 0 01.493.308l1.047 4.462a.415.415 0 01-.309.495z"
            fill="#74a1bd"
          />
          <path
            data-name="Path 912"
            d="M90.851 157.196l-5.3 1.244a.37.37 0 01-.37-.164.289.289 0 01.239-.378l5.331-1.125a.219.219 0 01.263.163.219.219 0 01-.163.26z"
            fill="#deebe9"
          />
          <path
            data-name="Path 913"
            d="M89.241 156.524l-4 .938a.286.286 0 01-.281-.136.224.224 0 01.179-.3l4.025-.845a.172.172 0 01.2.133.171.171 0 01-.123.21z"
            fill="#deebe9"
          />
          <path
            data-name="Path 914"
            d="M89.71 158.528l-4 .939a.284.284 0 01-.28-.136.224.224 0 01.177-.3l4.025-.843a.172.172 0 01.2.133.169.169 0 01-.121.207z"
            fill="#deebe9"
          />
          <path
            data-name="Path 915"
            d="M101.519 129.179l-3.294.349a.173.173 0 01-.19-.154l-.2-1.9a.173.173 0 01.153-.19l3.294-.349a.172.172 0 01.19.154l.2 1.9a.173.173 0 01-.153.19z"
            fill="#74a1bd"
          />
          <path
            data-name="Path 916"
            d="M100.846 128.204l-2.26.246a.157.157 0 01-.144-.086.123.123 0 01.123-.144l2.265-.189a.09.09 0 01.1.08.09.09 0 01-.084.093z"
            fill="#deebe9"
          />
          <path
            data-name="Path 917"
            d="M100.22 127.846l-1.7.181a.123.123 0 01-.11-.072.094.094 0 01.018-.079.093.093 0 01.072-.036l1.71-.141a.072.072 0 01.075.065.07.07 0 01-.06.08z"
            fill="#deebe9"
          />
          <path
            data-name="Path 918"
            d="M100.304 128.696l-1.7.18a.123.123 0 01-.109-.07.092.092 0 01.089-.116l1.71-.14a.072.072 0 01.076.066.073.073 0 01-.066.08z"
            fill="#deebe9"
          />
          <path
            data-name="Path 919"
            d="M80.268 124.875a.765.765 0 00-1.144.531c-.333 1.249.123 3.172.7 2.589a4.634 4.634 0 00.3-1.082s-.038 1.816.563 1.653.63-1.77.63-1.77.2 1.928.71 1.6.467-1.6.467-1.6.132 1.747.711 1.356.246-1.744.235-2.342c0-.563-.4-.658-.986-.64a.818.818 0 00-.926-.146c-.133.063-.354-.2-.459-.219a1.975 1.975 0 00-.801.07z"
            fill="#f7b686"
          />
          <path
            data-name="Path 920"
            d="M74.702 132.872s1.086-1.862 2.324-2.113 3.007.37 2.272.683a8.693 8.693 0 01-1.784.466s2.258-.209 2.078.341-2.145.711-2.145.711 2.712-.034 2.368.43-2.394.475-2.394.475 2.52.069 2.114.6-2.082-.07-2.262.478-1.08 2.67-2.668 2.357z"
            fill="#f7b686"
          />
          <path
            data-name="Path 921"
            d="M76.66 132.212l-.074-.057c.253-.329.9-.3.931-.295v.092s-.635-.031-.857.26z"
            fill="#dd8964"
          />
          <path
            data-name="Path 922"
            d="M76.414 133.322l-.06-.07a1.63 1.63 0 011.1-.341v.093a1.594 1.594 0 00-1.04.318z"
            fill="#dd8964"
          />
          <path
            data-name="Path 923"
            d="M76.462 134.2l-.079-.051c.239-.37 1.008-.334 1.042-.333l-.006.094s-.744-.036-.957.29z"
            fill="#dd8964"
          />
          <path
            data-name="Path 924"
            d="M71.112 137.407c-4.459 0-7.873-1.172-10.18-3.5a9.725 9.725 0 01-2.433-8.412s.155-.388 2.5-.02 2.331.91 2.331.91a4.318 4.318 0 001.081 4.151c1.763 1.747 5.728 2.876 10.293 2.342l-.025 4.453a30.306 30.306 0 01-3.567.076z"
            fill="#f7b686"
          />
          <g data-name="Group 115">
            <path
              data-name="Path 925"
              d="M64.078 135.193a1.15 1.15 0 01-.537-.143 1.11 1.11 0 01-.47-.45.527.527 0 01.435-.819 1.109 1.109 0 01.635.137c.44.233.662.677.493.986a.568.568 0 01-.461.28.745.745 0 01-.095.009zm-.471-1.248a.646.646 0 00-.081 0 .359.359 0 00-.3.571.945.945 0 00.4.38.953.953 0 00.539.123.4.4 0 00.329-.191c.123-.23-.069-.571-.425-.76a1 1 0 00-.461-.118z"
              fill="#e08b65"
              opacity={0.5}
            />
          </g>
          <path
            data-name="Path 926"
            d="M107.91 130.815c-.668-.657 1.674-3.7 1.674-3.7.255-.179 4.509 3.853 9.382 2.308 1.736-.55 4.137-3.588 4.314-4.04.023-.06 3.844 1.321 3.844 1.321-.313.817-.16 3.692-2.029 5.412-3.869 3.564-10.603 3.943-17.185-1.301z"
            fill="#f7b686"
          />
          <path
            data-name="Path 927"
            d="M130.955 179.293s-.033 1.319-.926 1.691-3.479.707-2.512 1.556c.553.493 3.167.172 3.905.172s1.43.322 1.978-.172c.6-.542 0-3.247 0-3.247a2.944 2.944 0 01-1.209.317 2.344 2.344 0 01-1.236-.317z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 928"
            d="M123.254 139.485s-.179 5.953 1.726 17.372c1.372 8.245 2.991 16.553 3.786 20.535a3.105 3.105 0 002.9 2.523l.763.031a2.608 2.608 0 002.67-2.825l-1.927-26.945-.476-8.875z"
            fill="#6f4975"
          />
          <path
            data-name="Path 929"
            d="M139.407 179.293s-.032 1.319-.926 1.691-3.479.707-2.512 1.556c.555.493 3.168.172 3.905.172s1.431.322 1.979-.172c.6-.542 0-3.247 0-3.247a2.951 2.951 0 01-1.209.317 2.344 2.344 0 01-1.237-.317z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 930"
            d="M131.708 139.485s-.177 5.953 1.726 17.372c1.372 8.245 2.99 16.553 3.786 20.535a3.105 3.105 0 002.9 2.523l.763.031a2.608 2.608 0 002.67-2.825l-1.928-26.945-.475-8.875z"
            fill="#6f4975"
          />
          <path
            data-name="Path 931"
            d="M142.08 146.008c-.019.719-4.361 1-9.732.836s-9.664-.91-9.646-1.628 4.34-1.14 9.713-.973 9.683 1.048 9.665 1.765z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 932"
            d="M140.766 125.675s-.949-3.765-7.957-3.8c-10.108-.054-9.17 9.232-10.108 23.344a63.366 63.366 0 0119.383.616s.877-14.407-1.318-20.16z"
            fill="#ced891"
          />
          <path
            data-name="Path 933"
            d="M143.352 125.135l-4.577 2.533s-10.022.91-12.683.471a4.259 4.259 0 01-3.39-2.391 14.674 14.674 0 017.65-3.714 13.977 13.977 0 011.408-.16 13.808 13.808 0 012.434.048c6.105.687 9.158 3.213 9.158 3.213z"
            fill="#ced891"
          />
          <path
            data-name="Path 934"
            d="M133.771 121.01l-.529-1.707-.154-.493-.9-2.923-.123 2.908-.07 1.744-.024.552c-.015.37-.246.454-.521.78-.113.132-.835.932-.016 1.293a3.8 3.8 0 003.65-1.124s-1.142-.478-1.313-1.03z"
            fill="#f7b686"
          />
          <path
            data-name="Path 935"
            d="M123.548 145.796s5.821-1.712 17.874.639l.094 1.738-17.671.616z"
            fill="#6f4975"
          />
          <path
            data-name="Path 936"
            d="M143.448 125.245c.388.548-.184 1.633-1.276 2.422s-2.294.986-2.682.435.184-1.635 1.276-2.424 2.294-.987 2.682-.433z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 937"
            d="M147.481 148.64a.417.417 0 01.335.485l-.646 3.506a.419.419 0 01-.487.335.419.419 0 01-.335-.486l.646-3.507a.419.419 0 01.487-.333z"
            fill="#f7b686"
          />
          <path
            data-name="Path 938"
            d="M146.429 148.446a.42.42 0 01.335.493l-.722 3.921a.42.42 0 01-.493.335.42.42 0 01-.335-.493l.724-3.921a.419.419 0 01.492-.335z"
            fill="#f7b686"
          />
          <path
            data-name="Path 939"
            d="M146.523 146.354l.1.112a.506.506 0 01-.049.711l-2.04 1.777a.507.507 0 01-.713-.049l-.1-.112a.507.507 0 01.049-.713l2.04-1.776a.506.506 0 01.713.05z"
            fill="#f7b686"
          />
          <path
            data-name="Path 940"
            d="M145.373 148.252a.42.42 0 01.335.487l-.579 3.144a.418.418 0 01-.487.334.416.416 0 01-.334-.486l.579-3.143a.418.418 0 01.486-.335z"
            fill="#f7b686"
          />
          <path
            data-name="Path 941"
            d="M148.562 146.774s.816 2.243-.081 3.683c-.309.493-3.389-.158-3.566-.791a9 9 0 01.423-2.712z"
            fill="#f7b686"
          />
          <path
            data-name="Path 942"
            d="M148.525 148.828a.419.419 0 01.335.486l-.578 3.137a.419.419 0 01-.485.334.418.418 0 01-.334-.485l.578-3.136a.419.419 0 01.484-.336z"
            fill="#f7b686"
          />
          <path
            data-name="Path 943"
            d="M144.704 147.247c-.422-4.639-1.388-11.271-3.6-16.519a16.253 16.253 0 00-1.125-2.342c-.322-.535.254-1.71 1.162-2.271a2.634 2.634 0 012.391-.179 13.9 13.9 0 011.331 2.638c2.062 4.684 3.3 10.725 3.8 18.52z"
            fill="#f7b686"
          />
          <path
            data-name="Path 944"
            d="M129.853 114.786a3.833 3.833 0 000 1.594c.185.888 1.086-1.293 1.086-1.293z"
            fill="#56335b"
          />
          <path
            data-name="Path 945"
            d="M129.745 116.637a2.643 2.643 0 112.167 3.443 2.9 2.9 0 01-2.167-3.443z"
            fill="#f7b686"
          />
          <path
            data-name="Path 946"
            d="M134.962 116.416l-1.257-.131a.912.912 0 01-.679-.41c-.258-.4-.567-.616-1.74-.567a2.471 2.471 0 01-2.626-1.6.892.892 0 011.342-.953c.746.377.425-.549 1.143-.647 1.34-.184 1.591.849 2.688.816 1.439-.044 4.016 1.049 2.793 3.582z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 947"
            d="M132.184 116.844a.053.053 0 01.023-.1.572.572 0 01.608.345.055.055 0 010 .041.054.054 0 01-.028.03.058.058 0 01-.07-.025.905.905 0 00-.5-.287.049.049 0 01-.033-.004z"
            fill="#060633"
          />
          <path
            data-name="Path 948"
            d="M132.412 117.519c-.033.123-.131.2-.218.175a.2.2 0 01-.1-.263c.033-.122.131-.2.219-.176a.2.2 0 01.099.264z"
            fill="#060633"
          />
          <path
            data-name="Path 949"
            d="M130.236 116.686a.039.039 0 01-.028-.026.063.063 0 01.021-.071.37.37 0 01.536.06.064.064 0 010 .074.041.041 0 01-.027.017.04.04 0 01-.031-.009.548.548 0 00-.446-.052.035.035 0 01-.025.007z"
            fill="#060633"
          />
          <path
            data-name="Path 950"
            d="M130.717 117.232c.015.123-.046.234-.136.246s-.177-.081-.192-.206.044-.235.136-.247.176.083.192.207z"
            fill="#060633"
          />
          <path
            data-name="Path 951"
            d="M136.626 116.5s-.863 1.872-2.1 2.011c0 0 .995-1.428-1.109-2.3a6.693 6.693 0 013.209.289z"
            fill="#56335b"
          />
          <path
            data-name="Path 952"
            d="M134.89 117.533a.508.508 0 11.206-.729.536.536 0 01-.206.729z"
            fill="#f7b686"
          />
          <path
            data-name="Path 953"
            d="M133.424 116.212s.168 1.572-.152 1.869a5.693 5.693 0 01-3.419.044 2.054 2.054 0 001.691 2.065 2.975 2.975 0 001.008 0 2.07 2.07 0 001.647-1.047 6.006 6.006 0 00-.166-1.393 1.357 1.357 0 01.314-1.07 2.027 2.027 0 00-.923-.468z"
            fill="#56335b"
          />
          <path
            data-name="Path 954"
            d="M130.373 118.693a5.315 5.315 0 001.7.133.819.819 0 01-1.026.657c-.525-.095-.674-.79-.674-.79z"
            fill="#fff"
          />
          <path
            data-name="Path 955"
            d="M130.16 112.625h-.021v-.072a.316.316 0 00.37-.275l.071.007a.4.4 0 01-.42.34z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 956"
            d="M130.863 114.891a4.687 4.687 0 01-.815-.34c-.542-.292-.844-.63-.873-.978a.552.552 0 01.13-.493c.17-.147.465-.078.724-.017l.112.026v.034l-.113-.026c-.246-.059-.536-.123-.693.01a.546.546 0 00-.123.466c.066.814 1.646 1.282 1.662 1.287z"
            fill="#fff"
          />
          <path
            data-name="Path 957"
            d="M133.975 113.237a2.8 2.8 0 01-1.28-.291 1.917 1.917 0 01-.571-.42l.027-.023a2.567 2.567 0 002.293.667v.036a3.6 3.6 0 01-.469.031z"
            fill="#fff"
          />
          <path
            data-name="Path 958"
            d="M145.799 136.805c-.33 0-.645-.344-.721-.811a1.15 1.15 0 01.075-.662.577.577 0 01.422-.356c.356-.058.715.3.8.8a1.15 1.15 0 01-.075.662.582.582 0 01-.423.356.528.528 0 01-.076.006zm-.145-1.663a.229.229 0 00-.052 0 .413.413 0 00-.293.258.97.97 0 00-.061.561c.065.4.339.7.6.662a.414.414 0 00.293-.259.976.976 0 00.062-.56c-.063-.381-.303-.666-.548-.666z"
            fill="#e08b65"
          />
          <path
            data-name="Path 959"
            d="M124.502 127.798l-.112-.031a9.363 9.363 0 011.294-2.415l.092.069a9.283 9.283 0 00-1.274 2.377z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 960"
            d="M133.75 159.183c-.008-.049-.789-4.9-1.325-6.623s-2.815-3.152-2.835-3.166l.061-.1c.023.014 2.342 1.479 2.888 3.228s1.32 6.59 1.328 6.64z"
            fill="#2f1a31"
          />
          <path
            data-name="Path 961"
            d="M108.972 129.61a.39.39 0 01-.457.311l-3.273-.616a.391.391 0 01-.311-.456.391.391 0 01.456-.311l3.274.616a.392.392 0 01.311.456z"
            fill="#f7b686"
          />
          <path
            data-name="Path 962"
            d="M109.157 128.629a.391.391 0 01-.456.311l-3.661-.7a.391.391 0 01-.311-.456.389.389 0 01.456-.311l3.661.7a.392.392 0 01.31.456z"
            fill="#f7b686"
          />
          <path
            data-name="Path 963"
            d="M111.112 128.727l-.1.09a.472.472 0 01-.666-.049l-1.649-1.921a.472.472 0 01.049-.666l.1-.091a.475.475 0 01.666.049l1.651 1.917a.473.473 0 01-.051.671z"
            fill="#f7b686"
          />
          <path
            data-name="Path 964"
            d="M109.342 127.647a.392.392 0 01-.456.311l-2.935-.558a.392.392 0 01-.311-.456.393.393 0 01.457-.311l2.934.558a.391.391 0 01.311.456z"
            fill="#f7b686"
          />
          <path
            data-name="Path 965"
            d="M110.708 130.63s-2.1.751-3.441-.095c-.465-.292.164-3.167.757-3.328a8.506 8.506 0 012.538.408z"
            fill="#f7b686"
          />
          <path
            data-name="Path 966"
            d="M108.788 130.586a.39.39 0 01-.456.309l-2.929-.556a.392.392 0 01-.309-.456.391.391 0 01.455-.309l2.929.556a.392.392 0 01.31.456z"
            fill="#f7b686"
          />
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
